import { render } from "./Profile.vue?vue&type=template&id=6aa37f85&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=6aa37f85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa37f85"],['__file',"src/views/Customers/Profile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6aa37f85"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6aa37f85', __exports__)) {
    api.reload('6aa37f85', __exports__)
  }
  
  module.hot.accept("./Profile.vue?vue&type=template&id=6aa37f85&scoped=true", () => {
    api.rerender('6aa37f85', render)
  })

}


export default __exports__